import { CartItem } from 'types/cart';
import { renewablePlan, nonRenewablePlan, certificationsOnlyPlan } from '../constants/subscription';

export const getPlan = (itemsInCart: CartItem[] | undefined, autoRenew: boolean) => {
  if (itemsInCart?.some((item) => item.id === 'premium')) {
    return autoRenew ? renewablePlan : nonRenewablePlan;
  } else {
    return certificationsOnlyPlan;
  }
};
